import React, { useState, useRef, useCallback, useEffect } from 'react'
import { Card, CardContent, Typography , Grid } from "@deere/fuel-react";
import { Form } from '@deere/ux.uxframe-react'
import ButtonsSection from '../components/ButtonsSection'
import SectionPage from './SectionPage'
import LeftMenu from '../components/LeftMenu'
import LeftRelatedLinks from '../components/LeftRelatedLinks'
import { useSelector } from 'react-redux'
import CustomAlert from '../components/CustomAlert'
import { isSupplierAllowed,getDateFromTimeStamp, isInterfactory } from '../utils/utils'
import { useHistory, useLocation } from 'react-router'
import { EMPTY_BODY, CTPAT_QUESTIONS_TO_VALIDATE, CTPAT, LHR, NON_OKTA_USER, LBL_SUCCESS, CLASSNAME_FILEINPUT } from '../utils/surveyLiterals'
import store from '../redux/store'
import { useTranslation } from "react-i18next";
import { validateDatePicker } from '../utils/validation'
import { useUserInfo } from '../providers/userProvider'
import { useOktaAuth } from '@okta/okta-react';
import { saveUserAnswers,uploadSurveyFile } from '../utils/saveSurveyUtils'
import { updateGenResponse } from '../redux/action/genericSurveyAction'
import { useDispatch } from 'react-redux'
import { savedSuccessFullySurvey } from '../redux/action/saveAction'
import {setFieldsWithErrors} from "../redux/action/validationAction";
import { getHelpDocPdfBySurveyId } from '../services/surveyHelpDoc.service';
import cookie from "js-cookie";

export default function SurveyPage({ survey, setSurvey, surveyLanguages, countryList }) {
    const userInfo = useUserInfo();
    const { authState } = useOktaAuth();
    const [validated, setValidated] = useState(false)
    const [errors, setErrors] = useState([])
    const surveySaved = useSelector((state) => state.save.saveSurvey)
    const sections = survey.sections;
    let sectionsTitles = [...sections.map((section,index)=> section.description)]
    const [actLink, setActLink] = useState(new Array(sectionsTitles.length).fill(""));
    const sectionsRef = useRef([new Array(sectionsTitles.length)]);
    const location = useLocation()
    const { t } = useTranslation();
    const campaign = store.getState().campaign.campaignAssigned;
    const surveyResponse = useSelector(state => state.genericSurvey.surveyResponses[survey.code]);
    const surveyAnswersForm = useSelector(state => state.genericSurvey.surveyAnswersForm[survey.code]);
    const dispatch = useDispatch();
    const history = useHistory();
    const [status,setStatus] = useState(false);
    const [answers, setAnswers] = useState([]);
    const [navMenuHeight, setNavMenuHeight] = useState(0);
    const [url, setUrl] = useState({ show: false, url: null })
    const [uploadedFiles, setUploadedFiles] = useState([]);
    let questionsToValidate 
    let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;
    let token = isAuthMethodOkta ? authState.accessToken.accessToken : "";
    
    useEffect(() => {
        if (survey && survey.code) {
          getHelpDocPdfBySurveyId(token, survey.id, cookie.get("i18next") || DEFAULT_LANGUAGE, isAuthMethodOkta)
            .then(async (response) => {
              if (response.status === 200) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                setUrl({ show: true, url: url });
              } else {
                setUrl({ show: false, url: null });
              }
            })
            .catch((err) => {
              console.log(err);
              setUrl({ show: false, url: null });
            });
        }
      }, []);
    
    if(survey.code===CTPAT){        
        questionsToValidate=survey.sections.find(s=>s.code === 'ctpat_sec1').questions.filter(q=>CTPAT_QUESTIONS_TO_VALIDATE.includes(q.code));
    }

    const [title] = useState({
        updatedByName: location && location.state ? location.state.updatedByName : '',
        supplierName: location && location.state ? location.state.supplierName : campaign.assignments[0].supplierName,
        surveyType: location && location.state ? location.state.surveyType : survey.description,
        updatedTs: location && location.state ? location.state.updatedTs : campaign.assignments[0].lastUpdatedTs
    })

    const handleScroll = useCallback(() => {
        const currentScrollPos = window.pageYOffset;
        let tmpActLink = new Array(sectionsTitles.length).fill("");
        let tmpRefs = []
        sectionsRef.current.map((section) => {
            if(section){
                ((currentScrollPos + 300) >= (section.offsetTop)) ? tmpRefs.push('active') : tmpRefs.push('')
            }
        }
        )
        tmpActLink[tmpRefs.lastIndexOf('active')] = 'active'
        setActLink(tmpActLink)
    }, [sectionsTitles.length, location.state]);

    const surveyTitle = () => {
        if (title) {
            if (!title.updatedByName || title.updatedByName === NON_OKTA_USER) {
                return (<div className='p-2'>
                    <h1>{title.surveyType}</h1>
                    <h5>{title.supplierName} </h5>
                     <h5>Due date {getDateFromTimeStamp(new Date(campaign.endDate))}</h5>

                </div>)
            }
            else {
                return (<div className='p-2'>
                    <h1>{title.surveyType}</h1>
                    <h5>{title.supplierName}</h5>
                    <h5>Due date {getDateFromTimeStamp(new Date(campaign.endDate))}</h5>
                    <h5> {` Last saved on ${title.updatedTs} by ${title.updatedByName} `}</h5>
                </div>)
            }
        }
        return null
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (!survey) {
        return EMPTY_BODY;
    }

    const getSectionsWithErrors = (form) => {
        const errSections = [];
        const answers = store.getState().genericSurvey.surveyAnswersForm[survey.code];
        survey?.sections?.forEach((sec) => {
          sec?.questions?.forEach((que) => {
            const questionDOM = document.getElementById(que.code);// checking of question is rendered or not
            if (que.required && questionDOM) {
              const index = answers ? answers.findIndex((ans) => ans.questionId === que.id) : -1;
              if (index === -1 || !answers[index].answer || answers[index].answer === "") {
                errSections.push(sec.description);
              }
            }
          });
        });
        return [...new Set(errSections)];
    };

    const handleSubmit = event => {
        const form = event.currentTarget;
        let errorSections = getSectionsWithErrors(form);
        const datePickerErrors = validateDatePicker(form)
        dispatch(setFieldsWithErrors(datePickerErrors))
        setErrors(errorSections);
        
        setValidated(true);
        event.preventDefault();
        event.stopPropagation();

        if (errorSections.length <= 0) {
            setValidated(false);
            let answers = store.getState().genericSurvey.surveyAnswersForm[survey.code] ? store.getState().genericSurvey.surveyAnswersForm[survey.code] : [];
            const updByName = location && location.state ? location.state.updatedByName : campaign.updatedByName;
            const supplierName = location && location.state ? location.state.supplierName : campaign.assignments[0].supplierName;
            const surveyType = survey.description;
            saveUserAnswers(surveyResponse, answers, campaign, userInfo, authState).then(response => {
                if(response.variant && response.variant === LBL_SUCCESS.toLowerCase()){
                    let i = 0;   
                    const selectElement = document.getElementsByClassName(CLASSNAME_FILEINPUT);                    
                    for (let element of selectElement){
                        i=i+1;
                        const inputFile = element && element.children ? element.children[0] : null;
                        if(inputFile && inputFile.value !== undefined && inputFile.value !== ''){                        
                            const cert = inputFile.files[0]
                            const fd = new FormData();                            
                            fd.append('file', cert);
                            fd.append('content-type','application/pdf');
                            
                            uploadSurveyFile(fd,campaign,'file'+ i, userInfo, authState).then(response => {
                            }).catch(error => {
                                console.log(error);
                            });
                        }
                    }
                    dispatch(updateGenResponse({surveyCode: survey.code, surveyResponse: response.updatedResponse}));
                    dispatch(savedSuccessFullySurvey(response));
                    
                    response.description = t('lbl_success_save_message');
                        history.push({
                            pathname: isAuthMethodOkta ? '/review' : '/reviewext',
                            state: {
                                previous: '/survey',
                                survey: survey,
                                updatedByName: updByName,
                                supplierName: supplierName,
                                surveyType: surveyType,
                                campaign: campaign,
                                answers: answers,
                                isAuthNonOkta : !isAuthMethodOkta,
                                updatedTs: location && location.state ? location.state.updatedTs : ""
                            }
                        })
                }else{
                    dispatch(savedSuccessFullySurvey(response));
                }
            }).catch(error => {
                console.log(error);
            });
        } else {
             window.scrollTo(0, 0);
        }

    }

    const shouldSectionRender = (section) => {
        let shouldRender = true;
        let depDetails = section && section.sectionDependency && Array.isArray(section.sectionDependency) ? section.sectionDependency : [];
        for(let i=0; i<depDetails.length; i++){
            shouldRender = false;
            let answersAvailable = surveyAnswersForm && surveyAnswersForm.length > 0 ? surveyAnswersForm : surveyResponse.surveyAnswers ? surveyResponse.surveyAnswers : [];
            if(answersAvailable.length > 0){
                let depAnswer = answersAvailable.find((ans)=>ans.questionId === depDetails[i].idQuestionDependson);
                if(depAnswer && depAnswer.answer === depDetails[i].idSelectionDependson.toString()){
                    shouldRender = true;
                    break;
                }
            }
        }
        return shouldRender;
    }

    const showErrorCard = <>
        <Card className='p-2 mb-2 bg-danger'>
            <CardContent  >
                <Typography  className='pb-3 text-white' variant="h2">
                    {t('lbl_error_survey_validation')}
                </Typography>
                {
                    errors.map((error, index) =>
                        <div key={index}>
                            <li className='text-white'>{error}</li>
                        </div>
                    )
                }
            </CardContent >
        </Card>
        <br />
    </>

    function clearErrors(){
        setValidated(false);
        setErrors([]);
    }

    function refreshStatus(){
        setStatus(!status);
    }

    if(!surveyResponse){
        return (<div>
            <h5>Loading...</h5>
        </div>)
    }

    return (<div>
        <Grid>
            {surveyTitle()}
        </Grid>
        <Grid container style={{display:"flex", flexFlow: "nowrap"}}>
            <Grid item xs={12} md={5}>
                {actLink.length > 0 && <LeftMenu actLink={actLink} survey={survey} setNavMenuHeight={setNavMenuHeight}/>}
                {survey.code===LHR && <LeftRelatedLinks surveyCode={survey.code} navMenuHeight={navMenuHeight}/>}
            </Grid>
            <Grid item xs={12} md={19}>
                {
                    errors.length > 0 ? showErrorCard : null
                }
                {
                    surveySaved.variant === 'success' ?
                        <CustomAlert accessibilityLabel={surveySaved.variant} variant={surveySaved.variant} title={surveySaved.description} />
                        : null
                }

                <Grid > 
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>               
                    {
                        sections.sort((a,b) => (a.showOrder > b.showOrder)? 1 : -1).map((section,index) =>{
                            return shouldSectionRender(section) ? 
                                <div key={index}>
                                    <div ref={el => sectionsRef.current[index] = el}>
                                        <SectionPage section={section} survey={survey} questionsToValidate={questionsToValidate} setAnswers={setAnswers}
                                        answers={answers} validated={validated} setValidated={setValidated} countryList={countryList} uploadedFiles={uploadedFiles} setUploadedFiles={setUploadedFiles}/>
                                    </div>
                                    <br />                        
                                </div> 
                            : 
                                ""
                        })
                    }
                    {((!isAuthMethodOkta)||(userInfo && (isSupplierAllowed(userInfo.userType) | isInterfactory(survey.code)))) &&
                        <ButtonsSection
                            setSurvey={setSurvey}
                            campaign={campaign} 
                            clearFunction={clearErrors}
                            survey={survey}
                            surveyLanguages={surveyLanguages}
                            url={url}
                            setUrl={setUrl}
                            uploadedFiles={uploadedFiles}
                        />
                    }  
                    </Form>                  
                </Grid>
            </Grid>
        </Grid >
    </div>
    )
}